export const SORT_DIRECTION = {
  ASC: "ASC",
  DESC: "DESC",
} as const

export type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION]
